import React, { Component } from "react";
import { connect } from "react-redux";

import ChargerTitle from "./ChargerTitle";
import OperatorInfo from "./OperatorInfo";
import PointInfo from "./PointInfo";
import PlugPicker from "./PlugPicker";
import POIs from "./POIs";

import { setAlert } from "../../../actions/alertActions";

import "../../../styles/components/map/chargerInfo/ChargerDetails.scss";

class ChargerDetails extends Component {
  render() {
    return (
      <div id="chargerDetails">
        <ChargerTitle
          charger={this.props.charger}
          isFavorite={
            this.props.favorites.findIndex(f => f._id === this.props.charger.properties._id) !== -1
          }
          toggleFavorite={this.props.toggleFavorite}
        />
        <OperatorInfo charger={this.props.charger} />
        <PointInfo currentLocation={this.props.currentLocation} charger={this.props.charger} />
        <hr />
        <PlugPicker charger={this.props.charger} />
        <hr />
        <POIs
          currentLocation={this.props.currentLocation}
          bbox={this.props.bbox}
          charger={this.props.charger}
        />
        {/* <div className="book-btn-container">
          <button type="button" className="secondary">
            <Translate value="chargerDetails_book" />
          </button>
        </div> */}
      </div>
    );
  }
}

export default connect(null, { setAlert })(ChargerDetails);
